function limitNumber(num: number, min: number, max: number) {
  return Math.max(min, Math.min(num, max));
}

/** 找到最接近 target 的符合特定条件的 index */
function findClosestIndex<T>(
  target: number,
  array: Array<T>,
  condition: (item: T) => boolean
): number {
  const twoPointer: [number, number] = [Math.floor(target), Math.ceil(target)];

  if (Number.isInteger(target)) {
    if (target === 0) {
      twoPointer[1]++;
    } else {
      twoPointer[0]--;
    }
  }

  let twoPointerIndex: 0 | 1 = twoPointer[1] - target >= 0.5 ? 0 : 1;
  while (
    twoPointer[twoPointerIndex] >= 0 &&
    twoPointer[twoPointerIndex] < array.length &&
    !condition(array[twoPointer[twoPointerIndex]])
  ) {
    if (twoPointerIndex) {
      twoPointer[twoPointerIndex]++;
      if (twoPointer[0] >= 0) {
        twoPointerIndex = 0;
      }
    } else {
      twoPointer[twoPointerIndex]--;
      if (twoPointer[1] < array.length) {
        twoPointerIndex = 1;
      }
    }
  }

  return twoPointer[twoPointerIndex];
}

/** 乱序数组中找到最接近 target 的值 */
function findClosest(target: number, array: number[]) {
  let diff = Infinity;
  let result;
  for (const item of array) {
    const newDiff = Math.abs(target - item);
    if (newDiff < diff) {
      diff = newDiff;
      result = item;
    }
  }
  return result;
}

/**阿拉伯数字转化为中文数字 */
function numberToChinese(num: number) {
  const changeNum = [
    '零',
    '一',
    '二',
    '三',
    '四',
    '五',
    '六',
    '七',
    '八',
    '九'
  ];
  const unit = ['', '十', '百', '千', '万'];
  const getWan = (temp: string | number) => {
    const strArr = temp.toString().split('').reverse();
    let newNum = '';
    for (let i = 0; i < strArr.length; i++) {
      newNum =
        (i == 0 && strArr[i] == '0'
          ? ''
          : i > 0 && strArr[i] == '0' && strArr[i - 1] == '0'
          ? ''
          : changeNum[Number(strArr[i])] +
            (strArr[i] == '0' ? unit[0] : unit[i])) + newNum;
    }
    return newNum;
  };
  const overWan = Math.floor(num / 10000);
  let noWan: string | number = num % 10000;
  if (noWan.toString().length < 4) noWan = '0' + noWan;
  return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num);
}
export { limitNumber, findClosestIndex, findClosest, numberToChinese };
